// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3-gnv","Label":"Checkbox_Label__S6IkI","InputElement":"Checkbox_InputElement__1GCLK","Invalid":"Checkbox_Invalid__3uds-"};